import {PayloadAction} from "../payload-action.interface";
import {RemarkEntity} from "./remark.entity";

export class RemarkActions{
  static readonly ADD 		  = '[RemarkActions] ADD';
  static readonly ADD_ALL 	= '[RemarkActions] ADD_ALL';
  static readonly REMOVE 		= '[RemarkActions] REMOVE';
  static readonly SET 		  = '[RemarkActions] SET';

  static addAll(remarks: Array<RemarkEntity>): PayloadAction{
    return {
      type: RemarkActions.ADD_ALL,
      payload: remarks
    }
  }

  static add(remark: RemarkEntity): PayloadAction{
    return {
      type: RemarkActions.ADD,
      payload: remark
    }
  }

  static set(remark: RemarkEntity): PayloadAction{

    return {
      type: RemarkActions.SET,
      payload: remark
    }
  }

  static remove(id: string): PayloadAction{
    return {
      type: RemarkActions.REMOVE,
      payload: id
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/remark/remark.actions.ts